import { render, staticRenderFns } from "./lid-dialog.vue?vue&type=template&id=3b3a722a&"
import script from "./lid-dialog.vue?vue&type=script&lang=js&"
export * from "./lid-dialog.vue?vue&type=script&lang=js&"
import style0 from "./lid-dialog.vue?vue&type=style&index=0&id=3b3a722a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports